
export function generateArray<T>(length: number, generator?: ((index?: number) => T)) {
  let array: T[] = [];

  array.length = length;

  if (generator !== undefined) {
    for (let i = 0; i < length; ++i)
      array[i] = generator(i);
  }

  return array;
}
